var _circle, _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _ellipse2, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmpty = function SvgEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 75.5,
    cy: 75,
    r: 75,
    fill: "#191C1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.5a2 2 0 0 1 2-2h107a2 2 0 0 1 2 2v10H20v-10Z",
    fill: "#464B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46.5h111V115a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V46.5Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.837,
    height: 3.852,
    rx: 1.918,
    transform: "matrix(1 0 0 -1 23.836 42.318)",
    fill: "#E37570"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.837,
    height: 3.852,
    rx: 1.918,
    transform: "matrix(1 0 0 -1 30.547 42.318)",
    fill: "#EFBA0F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.837,
    height: 3.852,
    rx: 1.918,
    transform: "matrix(1 0 0 -1 37.266 42.318)",
    fill: "#4ACC82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 46.5h22.5v69H28a2 2 0 0 1-2-2v-67Z",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.25,
    y: 59.171,
    width: 60.159,
    height: 46.83,
    rx: 4.5,
    fill: "#fff",
    stroke: "#E6E9ED",
    strokeMiterlimit: 16,
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 59.71,
    height: 46.227,
    rx: 2,
    transform: "matrix(-1 0 0 1 106.945 54.75)",
    fill: "#F4F6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.321 95.308c-.438-3.309-2.968-4.874-4.076-5.487-1.49-.824-3.56-1.32-6.504-1.32-2.944 0-5.014.496-6.504 1.32a8.958 8.958 0 0 0-1.73 1.294v2.193a2 2 0 0 0 2 2h16.814Zm-10.58-8.733c-3.145 0-5.694-2.586-5.694-5.776s2.55-5.776 5.694-5.776 5.694 2.586 5.694 5.776-2.55 5.776-5.694 5.776ZM100.553 90.643a10.36 10.36 0 0 0-1.458-.939c-1.514-.817-3.617-1.31-6.608-1.31-2.99 0-5.093.493-6.607 1.31-1.13.611-3.715 2.541-4.146 5.482H99.241a2.002 2.002 0 0 0 1.312-1.879v-2.664Zm-8.065-4.159c-3.195 0-5.784-2.566-5.784-5.73 0-3.165 2.59-5.73 5.784-5.73s5.784 2.565 5.784 5.73c0 3.164-2.59 5.73-5.784 5.73Z",
    fill: "#C9CED4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.57 95.186H91.14c-.592-4.631-4.148-6.819-5.701-7.674-2.081-1.145-4.973-1.834-9.085-1.834-4.112 0-7.004.69-9.085 1.835-1.554.854-5.11 3.557-5.7 7.673ZM68.402 74.981c0 4.431 3.56 8.023 7.953 8.023 4.392 0 7.953-3.592 7.953-8.023 0-4.43-3.56-8.022-7.953-8.022-4.392 0-7.953 3.592-7.953 8.022Z",
    fill: "#C9CED4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m101.432 138.849 10.157-5.603a.886.886 0 0 0 0-1.552l-11.441-6.312-11.441 6.312a.886.886 0 0 0 0 1.552l10.157 5.603c.8.441 1.769.441 2.568 0Z",
    fill: "#FE734F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.916 115.636h-3.544l-4.84 15.183s-.883 4.309 6.612 4.309 6.613-4.309 6.613-4.309l-4.841-15.183Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m105.766 127.706-1.275-3.998c-2.217 2.509-6.879 2.103-8.692.002l-1.275 3.996c.316.921 1.486 2.992 5.621 2.992 4.135 0 5.305-2.071 5.621-2.992ZM97.09 119.678c.583.687 1.53 1.274 3.06 1.274 1.531 0 2.477-.587 3.061-1.274l-1.289-4.042h-1.09c-.424.08-.858.077-1.278 0h-1.176l-1.289 4.042Z",
    fill: "#FE734F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.772,
    cy: 0.886,
    rx: 1.772,
    ry: 0.886,
    transform: "matrix(-1 0 0 1 101.922 114.75)",
    fill: "#FE734F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m17.865 124.599-10.157-5.603a.886.886 0 0 1 0-1.552l11.44-6.312 11.442 6.312a.886.886 0 0 1 0 1.552l-10.157 5.603c-.8.441-1.769.441-2.568 0Z",
    fill: "#FE734F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.38 101.386h3.545l4.84 15.183s.883 4.309-6.612 4.309-6.613-4.309-6.613-4.309l4.84-15.183Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m13.531 113.456 1.275-3.998c2.217 2.509 6.879 2.103 8.692.002l1.274 3.996c-.315.921-1.485 2.992-5.62 2.992s-5.305-2.071-5.62-2.992ZM22.208 105.428c-.584.687-1.53 1.274-3.061 1.274-1.53 0-2.477-.587-3.061-1.274l1.289-4.042h1.09c.424.08.858.077 1.278 0h1.176l1.289 4.042Z",
    fill: "#FE734F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.147,
    cy: 101.386,
    rx: 1.772,
    ry: 0.886,
    fill: "#FE734F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 54v2.426M15.5 58.125h-2.427M11.375 59.823v2.427M9.68 58.125H7.253M140.375 78.75v2.427M144.5 82.875h-2.426M140.375 84.573V87M138.68 82.875h-2.427",
    stroke: "#C9CED4",
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/empty.svg";